import { getPanelOptions } from '../utils';
import UrlSelectComponent from '72cms-ui/components/form-elements/UrlSelectComponent';
import RadioListComponent from '72cms-ui/components/form-elements/RadioListComponent';

export default {
    sections: ['details'],
    toolbar: ['add', 'edit', 'active', 'delete'],
    groups: {
        settings: {
            component: { template: `<div class="form-row">
                <div class="col">
                    <slot name="link_value" />
                    <slot name="fullwidth" />
                </div>
                <div class="col">
                    <slot name="link_label" />
                    <slot name="align" />
                </div>
            </div>` }
        }
    },
    fields: {
        type: {
            section: 'details',
            noTitle: true,
            readonly: true,
            position: 0,
            section: 'details',
            component: RadioListComponent,
            values: function (value) {
                return getPanelOptions([value]);
            },
        },
        name: {
            section: 'details',
            position: 1,
        },
        title: {
            section: 'details',
            position: 2,
        },
        link_value: {
            label: 'Link to',
            section: 'details',
            group: 'settings',
            component: UrlSelectComponent,
            position: 3,
            multiple: true,
            link: function () {
                const productId = _.get(this, '$route.params.id', '');

                return [
                    `/product_tabs/_ref_?filter=product_id:${productId}`,
                    '/pages/_ref_', '/categories/_ref_', '/products/_ref_',
                ]
            },
        },
        link_label: {
            label: 'Link label',
            section: 'details',
            group: 'settings',
            position: 4,
        },
        align: {
            section: 'details',
            group: 'settings',
            description: 'Choose how text and image align',
            position: 5,
        },
        fullwidth: {
            section: 'details',
            group: 'settings',
            cssClass: 'mt-3',
            description: 'Toggle this to set panel to fullwidth',
            position: 6,
        },
        image: {
            section: 'details',
            position: 7,
        },
        content: {
            section: 'details',
            position: 8,
        }
    }
}



// WEBPACK FOOTER //
// ./resources/assets/cms/js/config/form.panel-text-image.js